// extracted by mini-css-extract-plugin
export default {"titleWrapper":"Chat_titleWrapper__rKjma","username":"Chat_username__uH51P","logoutBtn":"Chat_logoutBtn__s2pXm"};